
@if(dataSourceQuantity){
    <ag-grid-angular #agGrid3 class="flex-grow-1 ag-theme-quartz" [rowData]="dataSourceQuantity" [columnDefs]="colDefsQunatity"
    [gridOptions]="gridOptionsQunatity" (gridReady)="onGridReadyQuantity($event)"
    (sortChanged)="onSortChangedQuantity($event)">
</ag-grid-angular>
}

